// extracted by mini-css-extract-plugin
export default {"productDiscountName":"AB8V9P"};